import { Environment } from '../../../common/types';
import { config } from '../../../configuration/config';

const isDev = import.meta.env.DEV;
export const buildClosingDaysServiceUrl = (): string => {
    if (isDev) {
        return import.meta.env.VITE_CLOSING_DAYS_SERVICE_DEV;
    }
    switch (config.environmentFromUri) {
        case Environment.RIO:
            return import.meta.env.VITE_CLOSING_DAYS_SERVICE_RIO;
        case Environment.VW_QA:
            return import.meta.env.VITE_CLOSING_DAYS_SERVICE_VW_QA;
        case Environment.VW:
            return import.meta.env.VITE_CLOSING_DAYS_SERVICE_VW;
        default:
            throw new Error('Could not build base url for closing days service');
    }
};
